import vademecum from "../../../services/masterMedicine/master-medicine";

import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            search: "",
            headers: [{
                    text: "Plu",
                    sortable: true,
                    value: "plu",
                },
                {
                    text: "Descripción",
                    sortable: true,
                    value: "description",
                },
                {
                    text: "¿Aplicable?",
                    sortable: false,
                    value: "isApplicable",
                },
                {
                    text: "¿Regulado?",
                    sortable: false,
                    value: "isWatched",
                },
            ],

            itemsData: [],
            nroRows: 0,
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchCity();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        searchCity() {
            vademecum.getVademecumOrder().then((response) => {
                this.itemsData = response.data;
                this.nroRows = response.data.length;
            });
        },
        getLenght() {
            console.log(this.nroRows);
            return this.nroRows;
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase();
            return items.filter((row) => filter(row["description"], search));
        },
    },
};